import { Link } from '@reach/router';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { userSignOut } from 'reducers/auth';
import Cookies from 'universal-cookie';
import { DropdownLinkData, menuLinks } from './menuLinks';

type HeaderDropdownMenuProps = {
  initials: string;
  linkListData: DropdownLinkData[];
};

export const HeaderDropdownMenu: React.FC<HeaderDropdownMenuProps> = ({
  initials,
  linkListData,
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const cookies = new Cookies();
  const cookieBannerSetting = cookies.get('cookie_settings');  

  const toggleIsOpen = () => {
    setIsOpen((oldVal) => !oldVal);
  };

  const bind = useOnClickOutside(() => setIsOpen(false));

  const handleSignOut = () => {
    dispatch(userSignOut());
  };

  return (
    <div className="HeaderDropdownMenu" {...bind}>
      <div className="OpenButton" onClick={toggleIsOpen}>
        <span>{cookieBannerSetting && cookieBannerSetting !== "functional" && cookieBannerSetting !== "functional_and_marketing" ? initials : "GS"}</span>
      </div>
      <div className={`Menu ${isOpen ? 'Open' : ''}`}>
        <ul>
          {menuLinks(linkListData)
            .filter((link) => link.label !== 'documents')
            .map((link) => (
              <li
                key={link.to}
                className={
                  'LinkItem' +
                  (link.label.toLowerCase().indexOf('upgrade') > -1
                    ? ' UpgradeLink'
                    : '')
                }
              >
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          <li onClick={handleSignOut}>
            <span className="SignOut">Sign out</span>
          </li>
        </ul>
      </div>
    </div>
  );
};
